import defaultAvatar from "@/assets/img/0.png";
import md5 from "md5";

const SHORT_AVATAR_PARTS = ["eyes", "hair", "head", "skin", "top"];
const PLAYER_AVATARS_PATH =
  "https://firebasestorage.googleapis.com/v0/b/chesssquad-1983a.appspot.com/o/avatars_128%2F";

export const DEFAULT_AVATAR = defaultAvatar;
export const BOT_AVATAR = require("@/assets/img/bot.png");

const getHashedDNA = function (dna) {
  const avatar = {
    dna: dna,
    settings: dna.split("|"),
    partIndex: function (part) {
      return this.settings.indexOf(part) + 1;
    },
    partValue: function (part) {
      return this.settings[this.partIndex(part)];
    },
  };
  const shortDNA = [
    avatar.settings[0],
    ...SHORT_AVATAR_PARTS.map((part) => [part, avatar.partValue(part)]),
  ]
    .flatMap((a) => a)
    .join("|")
    .trim();
  return md5(shortDNA);
};

export const getAvatarPath = function (dna) {
  if (!dna) return DEFAULT_AVATAR;
  if (dna === "bot") return BOT_AVATAR;

  const hashedDna = getHashedDNA(dna);
  return PLAYER_AVATARS_PATH + hashedDna + ".png?alt=media";
};
